export default __webpack_public_path__ + "static/frame-009-f2588eaf4578376f5482221c2a2a68e7.png";